import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { BlockViaSurveyComponent } from './block-viaSurvey.component';
import { BlockHtmlModule } from '@app/components/blocks/block-html/block-html.module';
import { BlockTextboxModule } from '@app/components/blocks/block-textbox/block-textbox.module';
import { BlockRadioboxModule } from '@app/components/blocks/block-radiobox/block-radiobox.module';
import { PlCheckboxModule } from '@app/components/pl-checkbox/pl-checkbox.module';
import { PlRadioModule } from '@app/components/pl-radio/pl-radio.module';
import { ButtonModule } from '@app/components/button/button.module';
import { BlockButtonModule } from '@app/components/blocks/block-button/block-button.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    PlInputModule,
    BlockHtmlModule,
    BlockTextboxModule,
    BlockRadioboxModule,
    PlCheckboxModule,
    PlRadioModule,
    ButtonModule,
    FormsModule,
    BlockButtonModule,
  ],
  declarations: [BlockViaSurveyComponent],
  exports: [BlockViaSurveyComponent],
})
export class BlockViaSurveyModule {}
